import {
  CheckboxProps,
  FormControlLabel,
  Checkbox as MuiCheckbox,
  Typography,
  TypographyProps,
  SxProps,
} from "@mui/material";
import { Icon, Link } from "..";

interface Props extends CheckboxProps {
  label?: string;
  labelVariant?: TypographyProps["variant"];
  textUrl?: string;
  linkUrl?: string;
  containerSx?: SxProps;
}

const Checkbox = ({
  label,
  textUrl,
  linkUrl,
  labelVariant = "textSm",
  containerSx,
  ...props
}: Props) => {
  const title = (
    <Typography
      display={"inline-block"}
      alignItems={"center"}
      variant={labelVariant}
    >
      {linkUrl && textUrl ? (
        <>
          {label}{" "}
          <Link to={linkUrl} smallFont target="_blank">
            {textUrl}
          </Link>
        </>
      ) : (
        label
      )}
    </Typography>
  );
  return (
    <FormControlLabel
      sx={{ m: 0, width: "fit-content", ...containerSx }}
      control={
        <MuiCheckbox
          {...props}
          disableFocusRipple
          disableRipple
          disableTouchRipple
          sx={{ padding: 0, mr: "4px" }}
          icon={
            <Icon
              icon="check_box_outline_blank"
              color="#222222"
              size={props.size === "small" ? 18 : 20}
            />
          }
        />
      }
      label={title}
    />
  );
};

export default Checkbox;
